import React, { useState, useEffect } from "react";
import axios from "axios";
import LoopIcon from '@mui/icons-material/Loop';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled';
const FileUploader = ({ allowSubmission, existingFile }) => {
  const [file, setFile] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasSubmittedFile, setHasSubmittedFile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [statusIcon, setstatusIcon] = useState("");
  const [statusColor, setstatusColor] = useState("");
  useEffect(() => {
    const fetchSubmission = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/submissions/`,
          { headers }
        );

        if (response.data.length > 0) {
          setHasSubmittedFile(false);
            if(response.data[0]['status'] == 'pending'){
                setstatusIcon(<LoopIcon className="animate-spin"/>);
                setstatusColor("yellow");
                response.data[0]['status'] = 'در انتظار بررسی';
            }
            if(response.data[0]['status'] == 'accepted'){
                setstatusIcon(<PublishedWithChangesIcon className="animate-pulse"/>);
                setstatusColor("lime");
                response.data[0]['status'] = 'تایید شده';
            }
            if(response.data[0]['status'] == 'rejected'){
                setstatusIcon(<SyncDisabledIcon  className="animate-pulse"/>);
                setstatusColor("red");
                response.data[0]['status'] = ' رد شده';
            }
            const cleanedFileName = response.data[0]['info'].replace("/media/submissions/", "").replace(response.data[0]['info_type'],"");
            response.data[0]['info'] = cleanedFileName;
          setFile(response.data[0]); // فرض می‌کنیم یک فایل برای هر کاربر مجاز است.
        }
      } catch (error) {
        console.error("خطا در بررسی فایل ارسال شده:", error);
        setStatusMessage("خطا در بررسی فایل ارسال شده.");
      } finally {
        setLoading(false);
      }
    };

    fetchSubmission(); // اینجا فقط یکبار فراخوانی می‌شود.
  }, []);
  // اگر فایل قبلاً وجود داشته باشد
  useEffect(() => {
    if (existingFile) {
      setFile(existingFile);
    }
  }, [existingFile]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      const allowedExtensions = ["jpg", "jpeg", "png", "ppt", "pdf","zip","docx","doc","rar"];
      if (!allowedExtensions.includes(fileExtension)) {
        setStatusMessage("فرمت فایل انتخاب شده مجاز نیست!");
        return;
      }
      setFile(selectedFile);
      setStatusMessage("");
      
    }
    setHasSubmittedFile(true);
  };


  const handleFileDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      handleFileChange({ target: { files: [droppedFile] } });
    }
  };

  const handleFileRemove = () => {
    setFile(null);
    setStatusMessage("فایل با موفقیت حذف شد.");
  };

  const handleSubmit = async () => {
    if (!file) {
      setStatusMessage("لطفاً یک فایل انتخاب کنید.");
      return;
    }
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("info", file);

    try {
      const token = localStorage.getItem("access_token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/submissions/`,
        formData,
        { headers }
      );
      setStatusMessage("فایل با موفقیت ارسال شد!");
      console.log("پاسخ سرور:", response.data);
    } catch (error) {
      console.error("خطا در ارسال فایل:", error);
      setStatusMessage("خطا در ارسال فایل.");
    } finally {
      setIsSubmitting(false);
      window.location.reload();
    }
  };

  if (hasSubmittedFile == false && file) {
    return (
      <div className="text-center p-4 border-2 border-slate-700 rounded-lg" dir="rtl">
        <p className="text-gray-700">شما یک فایل ارسال کرده‌اید:</p>
        <ul className="mt-2">
          <li><strong>نام فایل:</strong> {file.info}</li>
          <li><strong>نوع فایل:</strong> {file.info_type}</li>
          <li><strong>وضعیت:</strong> <span className={`text-${statusColor}-500`}> {statusIcon} {file.status || "نامشخص"}</span></li>
        </ul>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-4 border border-gray-300 rounded-lg bg-white">
      <h2 className="text-lg font-bold text-gray-800 mb-4">ارسال فایل</h2>

      {file ? (
        <div className="text-center">
          <p className="text-gray-700 mb-4">فایل انتخاب شده:</p>
          <p className="text-sm text-gray-500">{file.name}</p>
          <button
            onClick={handleFileRemove}
            className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            حذف فایل
          </button>
        </div>
      ) : (
        <div
          className="border-2 border-dashed border-gray-300 p-6 text-center rounded-lg cursor-pointer hover:border-gray-500"
          onDrop={handleFileDrop}
          onDragOver={(e) => e.preventDefault()}
        >
          <p className="text-gray-600">فایل خود را اینجا بکشید و رها کنید</p>
          <p className="text-sm text-gray-400 mt-2">یا</p>
          <input
            type="file"
            onChange={handleFileChange}
            className="hidden"
            id="fileInput"
          />
          <label
            htmlFor="fileInput"
            className="mt-2 inline-block bg-blue-500 text-white px-4 py-2 rounded cursor-pointer hover:bg-blue-600"
          >
            انتخاب فایل
          </label>
        </div>
      )}

      <button
        onClick={handleSubmit}
        className="mt-6 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        disabled={!file || !hasSubmittedFile || isSubmitting}
      >
        {isSubmitting ? "در حال ارسال..." : "ارسال"}
      </button>

      {statusMessage && (
        <p className="mt-4 text-sm text-red-600">{statusMessage}</p>
      )}
    </div>
  );
};

export default FileUploader;
